import {Basic} from "./Basic";

export class Slider
{
    constructor()
    {
        const container = document.body.querySelector('.w__project--media-slider');
        if(container)
        {
            container.classList.add('mod--processed');
            Slider.slider = container.querySelector('.w__project--media');
            Slider.slider.style.transform = '';
            const lastEl = Slider.slider.querySelector('li:last-child');
            Slider.width = Slider.slider.getBoundingClientRect()['width']
            Slider.maxWidth = (lastEl.getBoundingClientRect()['left'] + lastEl.getBoundingClientRect()['width'] - Slider.width) * -1;
            Slider.moved = 0;
        }
    }

    static move(el)
    {
        if(el.classList.contains('mod--next'))
        {
            Slider.moved -= Slider.width/1.5;
            if(Slider.moved < Slider.maxWidth)
            {
                Slider.moved = Slider.maxWidth;
            }
        }
        else
        {
            Slider.moved += Slider.width/1.5;
            if(Slider.moved > 0)
            {
                Slider.moved = 0;
            }
        }
        Slider.slider.style.transform = 'translateX(' + Slider.moved.toString() + 'px)';
    }
}